import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import { WebsiteMarketingCtaButton } from '../../common/websiteSection';

export const AccountSetupStepShell = styled.section`
  padding: clamp(2rem, 5vw, 3rem) ${theme.spacing.xl};
  background: #ffffff;
`;

export const AccountSetupStepContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const formCardStyles = `
  max-width: 800px;
  margin: 0 auto;
  padding: clamp(1.5rem, 4vw, 2.5rem);
  background: var(--login-form-bg);
  border: 1px solid var(--login-form-border);
  border-radius: 20px;
  box-shadow: var(--login-form-shadow);
`;

export const AccountSetupFormCard = styled.div`
  ${formCardStyles}
`;

export const AccountSetupForm = styled.form`
  ${formCardStyles}
`;

export const AccountSetupButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${theme.spacing.xl};
  gap: ${theme.spacing.md};

  @media (max-width: 480px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const AccountSetupBackButton = styled.button`
  border: 1.5px solid var(--login-form-border);
  border-radius: 999px;
  padding: 14px 28px;
  background: #ffffff;
  color: var(--login-form-text);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: var(--login-primary);
    color: var(--login-primary);
    background: rgba(72, 138, 236, 0.06);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const AccountSetupNextButton = styled(WebsiteMarketingCtaButton)`
  border-radius: 999px;
  padding: 14px 28px;
  box-shadow: none;
  background: var(--login-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    transform: none;
    box-shadow: none;
    background: var(--login-primary-dark);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;
